module.exports = __webpack_public_path__ + "img/lctripLogo.34f8f358.png";